import { Mono } from './Shell'
import { useTokenMeta } from '../hooks'
import { formatUnits18, short } from '../config'

/** An amount of any ERC-20 with the token's own decimals and symbol, read on-chain. */
export default function TokenAmount({ raw, token, digits = 4 }: { raw?: string | bigint; token?: string; digits?: number }) {
  const { symbol, decimals, loading } = useTokenMeta(token, true)
  if (raw === undefined) return <>—</>
  if (loading) return <>…</>
  return (
    <>
      {formatUnits18(raw, decimals ?? 18, digits)} <Mono style={{ fontSize: '0.6em' }}>{symbol ?? short(token)}</Mono>
    </>
  )
}
